import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { validateClientEnv } from "@/lib/env";

function readClientEnv() {
  return validateClientEnv({
    VITE_APP_URL: import.meta.env.VITE_APP_URL,
    VITE_PRIVY_APP_ID: import.meta.env.VITE_PRIVY_APP_ID,
    VITE_PRIVY_CLIENT_ID: import.meta.env.VITE_PRIVY_CLIENT_ID,
    VITE_BASE_CHAIN_ID: import.meta.env.VITE_BASE_CHAIN_ID,
    VITE_BASE_RPC_URL: import.meta.env.VITE_BASE_RPC_URL,
    VITE_USDC_TOKEN_ADDRESS: import.meta.env.VITE_USDC_TOKEN_ADDRESS,
    VITE_PLATFORM_WALLET_ADDRESS: import.meta.env.VITE_PLATFORM_WALLET_ADDRESS,
    VITE_WALLETCONNECT_PROJECT_ID: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID,
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  });
}

// 使用全局变量确保 singleton 在 HMR 下也能持久化
const globalForSupabase = globalThis as unknown as {
  supabaseClient: SupabaseClient | undefined;
};

function createNewClient(): SupabaseClient {
  const clientEnv = readClientEnv();
  return createClient(clientEnv.VITE_SUPABASE_URL, clientEnv.VITE_SUPABASE_ANON_KEY);
}

/**
 * 获取 Supabase 客户端（singleton）
 * 所有组件和函数都应使用此函数，避免创建多个 GoTrueClient 实例
 */
export function getBrowserSupabaseClient(): SupabaseClient | null {
  if (!globalForSupabase.supabaseClient) {
    try {
      globalForSupabase.supabaseClient = createNewClient();
    } catch {
      return null;
    }
  }
  return globalForSupabase.supabaseClient;
}

/**
 * @deprecated 使用 getBrowserSupabaseClient() 代替，避免创建多实例
 */
export function createBrowserSupabaseClient(): SupabaseClient {
  return getBrowserSupabaseClient() ?? createNewClient();
}

/**
 * @deprecated 使用 getBrowserSupabaseClient() 代替
 */
export function createBrowserSupabaseClientSafely(): SupabaseClient | null {
  return getBrowserSupabaseClient();
}
